/**
 * Link da sala de reunião do AXION para um atendimento.
 *
 * A sala não é cadastrada no AXION: `administrador/modulos/meeting/meeting/` só lê
 * `id` e `tipo` da query string e provisiona a sala no Jitsi self-hosted com o nome
 * `<tipo>-<id>` — a chamada é idempotente, então o mesmo `id` sempre cai na mesma
 * sala. Nada é gravado em `sala_virtual`, logo a sala não aparece na listagem do
 * módulo Vídeo Chamada.
 *
 * Por isso o `id` é montado aqui, de forma determinística, a partir do número do
 * contato e da inbox: o mesmo contato na mesma inbox gera sempre o mesmo link, e
 * contatos/inboxes diferentes nunca colidem. O link é público — quem tem a URL
 * entra pelo lobby, sem login no AXION.
 */

const CAMINHO_SALA = '/administrador/modulos/meeting/meeting/';

/**
 * Reduz a valor seguro para nome de sala do Jitsi: minúsculas, só [a-z0-9].
 *
 * Os separadores são **removidos**, não trocados por hífen: o número do contato pode
 * chegar formatado ("+55 (11) 99999-8888") ou cru ("5511999998888"), e os dois têm que
 * gerar o mesmo link — senão o mesmo contato cairia em salas diferentes. Vale também
 * para contatos de Instagram/Messenger, cujo código é alfanumérico.
 */
function normalizar(valor: string): string {
    return valor.toLowerCase().replace(/[^a-z0-9]/g, '');
}

export function montarIdSalaReuniao(codigoContato: string, idInbox: string): string {
    // O id da inbox é um UUID (32 hex depois de normalizado), de tamanho fixo — então
    // não há como dois pares (inbox, contato) diferentes gerarem o mesmo id.
    return `whiz-${normalizar(idInbox)}-${normalizar(codigoContato)}`;
}

export function montarLinkSalaReuniao(urlAxion: string, codigoContato: string, idInbox: string): string {
    const base = urlAxion.endsWith('/') ? urlAxion.slice(0, -1) : urlAxion;

    const url = new URL(`${base}${CAMINHO_SALA}`);
    url.searchParams.set('id', montarIdSalaReuniao(codigoContato, idInbox));
    url.searchParams.set('tipo', 'sala_geral');

    return url.toString();
}
